// extracted by mini-css-extract-plugin
export var childrenContainer = "_redotech-redo-web-lib-arbiter-components-list-redo-list-children-container";
export var virtualScrollArea = "_redotech-redo-web-lib-arbiter-components-list-redo-list-virtual-scroll-area";